import { FilterSlider } from "components/FilterSlider";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React, { FC } from "react";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div<Props>`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    align-items: end;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const subFilters = [
    {
        id: "filter-prijs-min",
        param: "prijs.min",
        key: "prijs-min",
        seSubParam: "min",
        helpText: "Van ",
        ariaLabel: "prijs vanaf"
    },
    {
        id: "filter-prijs-max",
        param: "prijs.max",
        key: "prijs-max",
        seSubParam: "max",
        helpText: "Tot",
        ariaLabel: "prijs tot"
    }
] as const;

interface Props {
    condensed?: boolean;
}

export const PrijsFilter: FC<Props> = ({ condensed }) => {
    const priceCount = useCount("prijs");
    const [, , onMinChange] = useField("minimumprijs");
    const [, , onMaxChange] = useField("maximumprijs");

    return (
        <Grid condensed={condensed}>
            <FilterSlider
                subFilters={subFilters}
                aggregations={priceCount}
                handleChange={(name, value) =>
                    name === "filter-prijs-min" ? onMinChange(value) : onMaxChange(value)
                }
            />
        </Grid>
    );
};

PrijsFilter.displayName = "PrijsFilter";
